(function () {
  var WARRANTY_PRODUCT_ID = 9481608986910;
  var WARRANTY_HANDLE = 'maingear-warranty-upgrade-preconfigured';
  var DESKTOP_TYPES = ['Pre-configured PC', 'System'];
  var POLL_INTERVAL_MS = 400;

  /* Outlet rule: a line counts as an outlet item only when its vendor is exactly
     "MAINGEAR Outlet Store" (case-insensitive, trimmed). The regular "MAINGEAR"
     vendor and every other vendor never match, so they are unaffected. */
  var OUTLET_VENDOR = 'maingear outlet store';
  var NOTICE_CLASS = 'mg-outlet-warranty-notice';
  var NOTICE_TEXT = 'Warranty upgrades are not available for MAINGEAR Outlet Store items. Please remove the warranty upgrade to check out.';
  var NOTICE_STYLE = 'display:block;flex:1 1 100%;width:100%;box-sizing:border-box;margin:12px 0;padding:8px 10px;font-size:13px;line-height:1.4;font-weight:600;color:#ffb066;background:rgba(255,140,26,.12);border:1px solid #ff8c1a;border-radius:2px;text-align:left';

  /* Express checkout buttons (Shop Pay and other dynamic checkout buttons) on the
     cart page. They bypass the disabled checkout button, so they are hidden with
     CSS while the outlet + warranty conflict exists. Add selectors here if the
     theme renders them under a different tag or class. */
  var GUARD_ATTR = 'data-mg-outlet-guard';
  var HIDE_SELECTORS = [
    '.additional-checkout-buttons',
    'shopify-accelerated-checkout-cart',
    'shop-pay-wallet-button',
    '.shopify-payment-button',
    '[data-shopify="payment-button"]'
  ];

  function ensureGuardStyle() {
    if (document.getElementById('mg-outlet-guard-style')) return;
    var css = HIDE_SELECTORS.map(function (sel) {
      return 'html[' + GUARD_ATTR + '] ' + sel;
    }).join(',') + '{display:none !important}';
    var style = document.createElement('style');
    style.id = 'mg-outlet-guard-style';
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }

  function isOutletItem(item) {
    return String(item.vendor || '').trim().toLowerCase() === OUTLET_VENDOR;
  }

  function isWarrantyItem(item) {
    return item.product_id === WARRANTY_PRODUCT_ID || item.handle === WARRANTY_HANDLE;
  }

  function removeAllWarrantyCards(list) {
    var links = list.querySelectorAll('a[href*="' + WARRANTY_HANDLE + '"]');
    links.forEach(function (a) {
      var node = a;
      while (node.parentElement && node.parentElement !== list) {
        node = node.parentElement;
      }
      if (node.parentElement === list) {
        node.remove();
      }
    });
  }

  function getLimit(container) {
    var url = container.getAttribute('data-url') || '';
    var match = url.match(/[?&]limit=(\d+)/);
    return match ? parseInt(match[1], 10) : null;
  }

  function trimToLimit(list, limit) {
    if (!limit) return;
    while (list.children.length > limit) {
      list.lastElementChild.remove();
    }
  }

  function applyToDom(wrapper, container, cart) {
    var hasWarranty = cart.items.some(isWarrantyItem);
    var hasOutlet = cart.items.some(isOutletItem);
    var hasDesktop = cart.items.some(function (i) {
      return DESKTOP_TYPES.indexOf(i.product_type) !== -1;
    });

    var list = container.querySelector('ul.products') || container.querySelector('.complementary-products--inner');

    /* No warranty offer when: no desktop in the cart, the warranty is already
       in the cart, or any MAINGEAR Outlet Store item is in the cart. In all
       three cases also strip any warranty card the recommendations rendered. */
    if (!hasDesktop || hasWarranty || hasOutlet) {
      if (list) {
        var stray = list.querySelectorAll('a[href*="' + WARRANTY_HANDLE + '"]');
        if (stray.length) removeAllWarrantyCards(list);
      }
      return;
    }

    var template = wrapper.querySelector('template[data-warranty-template]');
    if (!template) return;

    if (!list) {
      var heading = document.createElement('div');
      heading.className = 'complementary-products--heading';
      heading.textContent = 'You may also like';
      var inner = document.createElement('div');
      inner.className = 'complementary-products--inner';
      container.appendChild(heading);
      container.appendChild(inner);
      list = inner;
    }

    var existingLinks = Array.prototype.slice.call(list.querySelectorAll('a[href*="' + WARRANTY_HANDLE + '"]'));
    function toCard(a) {
      var node = a;
      while (node.parentElement && node.parentElement !== list) {
        node = node.parentElement;
      }
      return node.parentElement === list ? node : null;
    }
    var cards = existingLinks.map(toCard).filter(Boolean);
    var uniqueCards = [];
    cards.forEach(function (c) {
      if (uniqueCards.indexOf(c) === -1) uniqueCards.push(c);
    });

    if (uniqueCards.length === 0) {
      var clone = template.content.cloneNode(true);
      list.insertBefore(clone, list.firstChild);
    } else {
      var keep = uniqueCards[0];
      for (var i = 1; i < uniqueCards.length; i++) {
        uniqueCards[i].remove();
      }
      if (list.firstElementChild !== keep) {
        list.insertBefore(keep, list.firstChild);
      }
    }

    trimToLimit(list, getLimit(container));
  }

  /* Find where the notice goes on the cart page: directly above the terms
     checkbox. Looks for a checkbox outside the drawer whose id, name or class
     mentions terms / agree / conditions, or any required checkbox, preferring
     ones inside the same form as the checkout button. If the checkbox shares a
     container with the checkout button, the notice goes right above the
     checkbox itself, otherwise above the checkbox's own wrapper. */
  function findTermsAnchor(btn) {
    var scope = (btn && btn.closest('form')) || document;
    var boxes = Array.prototype.filter.call(
      scope.querySelectorAll('input[type="checkbox"]'),
      function (el) {
        if (el.closest('#Cart-Drawer')) return false;
        var key = (el.id || '') + ' ' + (el.name || '') + ' ' + (el.className || '');
        return /term|agree|condition/i.test(key) || el.required;
      }
    );
    if (!boxes.length) return null;
    var box = boxes[0];
    var parent = box.parentNode;
    if (parent && btn && !parent.contains(btn)) return parent;
    return box;
  }

  /* Cart page guard (anything outside #Cart-Drawer).
     The drawer renders its own notice and disabled button in Liquid, so it is
     skipped here. On the cart page this shows one notice near the total, directly
     above the "agree to the terms of sale" checkbox (or above the checkout button
     if no such checkbox is found), disables the checkout buttons and hides the
     express checkout buttons. It only disables buttons it disabled itself and only
     removes the notice it created, so it never fights other rules such as the
     limit-one check. This is UI only. The checkout Function is the real
     enforcement, since dynamic checkout buttons and direct /checkout links
     cannot be blocked from the storefront. */
  function applyCheckoutGuard(cart) {
    var conflict = cart.items.some(isOutletItem) && cart.items.some(isWarrantyItem);

    var buttons = Array.prototype.filter.call(
      document.querySelectorAll('button[name="checkout"], input[name="checkout"]'),
      function (btn) { return !btn.closest('#Cart-Drawer'); }
    );

    var isCartPage = buttons.length > 0 || /\/cart\/?$/.test(window.location.pathname);

    /* Hide express checkout buttons only on the cart page, only during the conflict. */
    if (conflict && isCartPage) {
      document.documentElement.setAttribute(GUARD_ATTR, '1');
    } else {
      document.documentElement.removeAttribute(GUARD_ATTR);
    }

    buttons.forEach(function (btn) {
      if (conflict) {
        if (!btn.disabled) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          btn.setAttribute('data-outlet-guard', '1');
        }
      } else if (btn.getAttribute('data-outlet-guard') === '1') {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('data-outlet-guard');
      }
    });

    var notices = document.querySelectorAll('.' + NOTICE_CLASS + '[data-js="1"]');

    if (!conflict || !isCartPage) {
      Array.prototype.forEach.call(notices, function (n) { n.remove(); });
      return;
    }

    /* Above the terms checkbox when there is one, otherwise above checkout. */
    var anchor = findTermsAnchor(buttons[0]) || buttons[0];
    if (!anchor || !anchor.parentNode) return;

    var notice = notices[0];
    for (var i = 1; i < notices.length; i++) notices[i].remove();

    if (!notice) {
      notice = document.createElement('p');
      notice.className = NOTICE_CLASS;
      notice.setAttribute('data-js', '1');
      notice.setAttribute('role', 'alert');
      notice.setAttribute('style', NOTICE_STYLE);
      notice.textContent = NOTICE_TEXT;
    }
    if (notice.nextElementSibling !== anchor) {
      anchor.parentNode.insertBefore(notice, anchor);
    }
  }

  var scanBusy = false;

  function scan() {
    if (scanBusy) return;
    scanBusy = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-warranty-wrapper]').forEach(function (wrapper) {
          var container = wrapper.querySelector('product-recommendations');
          if (!container) return;
          applyToDom(wrapper, container, cart);
        });
        applyCheckoutGuard(cart);
      })
      .catch(function () {})
      .then(function () {
        scanBusy = false;
      });
  }

  function hookCartRequests() {
    var CART_URL_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?/;

    var originalFetch = window.fetch;
    if (originalFetch) {
      window.fetch = function () {
        var urlArg = arguments[0];
        var urlStr = typeof urlArg === 'string' ? urlArg : (urlArg && urlArg.url) || '';
        var result = originalFetch.apply(this, arguments);
        if (CART_URL_PATTERN.test(urlStr)) {
          result.then(function () {
            scan();
            setTimeout(scan, 150);
            setTimeout(scan, 400);
            setTimeout(scan, 800);
          }).catch(function () {});
        }
        return result;
      };
    }

    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (CART_URL_PATTERN.test(url)) {
        this.addEventListener('loadend', function () {
          scan();
          setTimeout(scan, 150);
          setTimeout(scan, 400);
          setTimeout(scan, 800);
        });
      }
      return originalOpen.apply(this, arguments);
    };
  }

  function start() {
    ensureGuardStyle();
    hookCartRequests();
    scan();
    setInterval(scan, POLL_INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
